import Phaser from 'phaser';
import PreloadScene from '../scenes/PreloadScene.js';
import SelectGroupScene from '../scenes/SelectGroupScene.js';
import StartScene from '../scenes/StartScene.js';
import IntroScene from '../scenes/IntroScene.js';
import HelpScene from '../scenes/HelpScene.js';
import CreditsScene from '../scenes/CreditsScene.js';
import VillageScene from '../scenes/VillageScene.js';
import BuildingScene from '../scenes/BuildingScene.js';
import BattleScene from '../scenes/BattleScene.js';
import FriendScene from '../scenes/FriendScene.js';
import ReflectionScene from '../scenes/ReflectionScene.js';
import FinaleScene from '../scenes/FinaleScene.js';
import SessionManager from './SessionManager.js';
import Conversations from './Conversations.js';

// Initialize session manager
window.sessionManager = new SessionManager();
window.conversations = Conversations;
window.sessionManager.start();

const config = {
  type: Phaser.AUTO,
  width: 800,
  height: 600,
  scene: [PreloadScene, SelectGroupScene, StartScene, IntroScene, HelpScene, CreditsScene, VillageScene, BuildingScene, BattleScene, FriendScene, ReflectionScene, FinaleScene],
  parent: 'game',
  physics: { default: 'arcade', arcade: { debug: false } },
  scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH
  }
};


const game = new Phaser.Game(config);

